import React from 'react';
import { Chip, Tooltip } from '@heroui/react';
import { ResponsiveTooltip, Typography } from '../../../../components';
import { InfoCircle } from '../../../../components/icons';
import { useTranslations } from '../../../../contexts/translation.context';
import { StatusCellProps } from '../types';

const StatusCell: React.FC<StatusCellProps> = ({ campaign }) => {
  const { t } = useTranslations();

  const getStatusConfig = (status: string) => {
    switch (status) {
      case 'active':
      case 'in_progress':
        return {
          dot: 'bg-success', // Green
          label: t('campaigns.status.active') || 'Активна',
        };
      case 'moderation':
      case 'in_moderation':
        return {
          dot: 'bg-warning', // Yellow
          label: t('campaigns.status.moderation') || 'На модерации',
        };
      case 'waiting':
        return {
          dot: 'bg-warning', // Yellow
          label: t('campaigns.status.waiting') || 'Ожидание',
        };
      case 'deactivated':
      case 'canceled':
      case 'inactive':
        return {
          dot: 'bg-auth-strength-weak', // Red
          label: t('campaigns.status.inactive') || 'Не активна',
        };
      case 'completed':
        return {
          dot: 'bg-success', // Green
          label: t('campaigns.status.completed') || 'Завершено',
        };
      default:
        return {
          dot: 'bg-auth-muted', // Gray
          label: status,
        };
    }
  };

  const statusConfig = getStatusConfig(campaign.status);
  const isActive = campaign.status === 'active' || campaign.status === 'in_progress';

  return (
    <div className="flex items-center gap-1">
      <Chip
        className="bg-auth-surface rounded-2 h-6 px-2"
        classNames={{
          content: 'flex items-center gap-1 px-0',
        }}
        size="sm"
      >
        <div className={`size-[0.4375rem] rounded-full ${statusConfig.dot}`}></div>
        <Typography variant="body3" className="text-auth-ink text-xs font-normal leading-4">
          {statusConfig.label}
        </Typography>
      </Chip>
      {isActive && (
        <ResponsiveTooltip
          content={
            <div className="bg-white border border-[rgba(229,231,235,0.72)] rounded-2 px-4 py-2 shadow-[0px_1px_3px_0px_rgba(0,0,0,0.1),0px_1px_2px_0px_rgba(0,0,0,0.06)]">
              <p className="text-auth-ink text-sm font-medium leading-5 mb-0">
                {t('campaigns.status.stopCampaignTooltip.line1')}
              </p>
              <p className="text-auth-ink text-sm font-medium leading-5 mb-0">
                {t('campaigns.status.stopCampaignTooltip.line2')}
              </p>
            </div>
          }
          placement="top"
          showArrow={false}
          classNames={{
            content: 'p-0 bg-transparent shadow-none',
          }}
        >
          <span className="cursor-pointer flex items-center">
            <InfoCircle size={16} className="text-neutral-8" />
          </span>
        </ResponsiveTooltip>
      )}
    </div>
  );
};

export default StatusCell;
